// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"6BiUY":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pressScale", ()=>pressScale);
var _reactAriaComponents = require("react-aria-components");
function pressScale(ref, style) {
    return (0, _reactAriaComponents.composeRenderProps)(style, (style, renderProps)=>{
        if (renderProps.isPressed && ref.current) {
            let { width = 0, height = 0 } = ref.current.getBoundingClientRect() ?? {};
            return {
                ...style,
                willChange: `${style?.willChange ?? ''} transform`,
                transform: `${style?.transform ?? ''} perspective(${Math.max(height, width / 3, 24)}px) translate3d(0, 0, -2px)`
            };
        } else return {
            ...style,
            willChange: `${style?.willChange ?? ''} transform`
        };
    });
}

},{"react-aria-components":"8nuKL","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gJckc":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
parcelHelpers.export(exports, "useFormProps", ()=>useFormProps);
parcelHelpers.export(exports, "Form", ()=>_Form);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
const FormContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useFormProps(props) {
    let ctx = (0, _react.useContext)(FormContext);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    return (0, _react.useMemo)(()=>{
        let result = props;
        if (ctx || isSkeleton) result = {
            ...props
        };
        if (ctx) {
            // This is a subset of mergeProps. We just need to merge non-undefined values.
            for(let key in ctx)if (result[key] === undefined) result[key] = ctx[key];
        }
        // Skeleton always wins over local props.
        if (isSkeleton) result.isDisabled = true;
        return result;
    }, [
        ctx,
        props,
        isSkeleton
    ]);
}
function Form(props, ref) {
    let { labelPosition = 'top', labelAlign, necessityIndicator, isRequired, isDisabled, isEmphasized, size = 'M', ...formProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...formProps,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            rules += ' _Zf';
            if (props.labelPosition === "side") rules += ' __h-hgmn7f';
            else if (props.labelPosition === "top") rules += ' __h-nvqmqy';
            if (props.size === "XL") rules += ' il';
            else if (props.size === "L") rules += ' ij';
            else if (props.size === "M") rules += ' ih';
            else if (props.size === "S") rules += ' ig';
            else if (props.size === "XS") rules += ' if';
            rules += ' jF';
            return rules;
        }({
            labelPosition,
            size
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormContext.Provider, {
            value: {
                labelPosition,
                labelAlign,
                necessityIndicator,
                isRequired,
                isDisabled,
                isEmphasized,
                size
            },
            children: props.children
        })
    });
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */ let _Form = /*#__PURE__*/ (0, _react.forwardRef)(Form);
try {
    // @ts-ignore
    useFormProps.displayName = "useFormProps";
    // @ts-ignore
    useFormProps.__docgenInfo = {
        "description": "",
        "displayName": "useFormProps",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Form elements are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Form elements are rendered with their emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the label is labeling a required field or group.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Form elements.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#useFormProps"] = {
        docgenInfo: useFormProps.__docgenInfo,
        name: "useFormProps",
        path: "packages/@react-spectrum/s2/src/Form.tsx#useFormProps"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    FormContext.displayName = "FormContext";
    // @ts-ignore
    FormContext.__docgenInfo = {
        "description": "",
        "displayName": "FormContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "FormStyleProps"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#FormContext"] = {
        docgenInfo: FormContext.__docgenInfo,
        name: "FormContext",
        path: "packages/@react-spectrum/s2/src/Form.tsx#FormContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Form.displayName = "_Form";
    // @ts-ignore
    _Form.__docgenInfo = {
        "description": "Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.",
        "displayName": "_Form",
        "props": {
            "action": {
                "defaultValue": null,
                "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
                "name": "action",
                "required": false,
                "type": {
                    "name": "string | ((formData: FormData) => void)"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"sentences\""
                        },
                        {
                            "value": "\"words\""
                        },
                        {
                            "value": "\"characters\""
                        }
                    ]
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        }
                    ]
                }
            },
            "encType": {
                "defaultValue": null,
                "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
                "name": "encType",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"application/x-www-form-urlencoded\""
                        },
                        {
                            "value": "\"multipart/form-data\""
                        },
                        {
                            "value": "\"text/plain\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Form elements are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Form elements are rendered with their emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the label is labeling a required field or group.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "method": {
                "defaultValue": null,
                "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
                "name": "method",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"get\""
                        },
                        {
                            "value": "\"post\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": null,
                "description": "An ARIA role override to apply to the form element.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"presentation\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Form elements.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"_self\""
                        },
                        {
                            "value": "\"_blank\""
                        },
                        {
                            "value": "\"_parent\""
                        },
                        {
                            "value": "\"_top\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "validationErrors": {
                "defaultValue": null,
                "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
                "name": "validationErrors",
                "required": false,
                "type": {
                    "name": "ValidationErrors"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "Triggered for each invalid field when a user submits the form.",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "Triggered when a user resets the form.",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "Triggered when a user submits the form.",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLFormElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#_Form"] = {
        docgenInfo: _Form.__docgenInfo,
        name: "_Form",
        path: "packages/@react-spectrum/s2/src/Form.tsx#_Form"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"llOt3","react/jsx-runtime":"2JzhG","react":"jEiK2","react-aria-components":"8nuKL","@react-spectrum/utils":"bebxO","./Skeleton":"2hWWB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"llOt3":[function() {},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.3ce8c54a.js.map
